export default {
    limitYearField(value = '') {
        if (typeof value !== 'string') return ''
        return value.replace(/^(\d{4})\d+/, '$1')
    },

    limiteInputOnlyDate(value = '') {
        if(typeof value !== 'string') return ''

        const numbers = value.replace(/\D/g, '').slice(0, 8)

        if(numbers.length <= 4) return numbers
        if(numbers.length <= 6) {
          return `${numbers.slice(0, 4)}-${numbers.slice(4)}`
        }

        return `${numbers.slice(0, 4)}-${numbers.slice(4, 6)}-${numbers.slice(6, 8)}`
    }
}